var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
});

import useHeader from "./partial/Header";
import useSlider from "./partial/Slider";

const { toggleMenu } = useHeader();

jQuery(function () {
    toggleMenu();
});
